import { GenericRule, GenericRuleFactory } from '../../../../../utils/genericValidator.util';
import { OfflineOrder } from '../OfflineOrder';
import { CreateOrderValidatorRulesParams } from './offlineOrderValidator.types';
import { ValidateOrderProductsPriceTableRule } from './rules/ValidateOrderProductsPriceTable.rule';

export class OfflineOrderRulesValidatorFactory implements GenericRuleFactory<OfflineOrder> {
  create({ useRulesTo }: CreateOrderValidatorRulesParams): GenericRule<OfflineOrder>[] {
    switch (useRulesTo) {
      case 'CHANGE_PRICE_TABLE':
        return this.createForChangePriceTable();
    }
  }

  private createForChangePriceTable(): GenericRule<OfflineOrder>[] {
    return [new ValidateOrderProductsPriceTableRule()];
  }
}
